module.exports = __webpack_public_path__ + "static/img-footer-bg-1b7314a6ce103c00622710b7b06f33cf.jpg";